<template>
  <div class="container">
    <b-container fluid>
      <b-row>
        <div class="header-wrapper mt-2">
          <b-button @click="back_to_button" variant="outline-primary"
            >Back to Dashboard</b-button
          >
        </div>
        <div class="header-wrapper ml-2 mt-2">
          <b-form-select
            v-model="selected_indicator"
            :options="indicator_options"
          ></b-form-select>
        </div>
      </b-row>
      <b-row align-h="center" class="mt-2">
        <VueTradingView :options="chartOption" :symbol="selectSymbol" />
      </b-row>
      <b-row align-h="center">
        <div class="header-wrapper mt-3">
          <b-table
            striped
            hover
            bordered
            head-variant="dark"
            light
            sticky-header
            no-border-collapse
            table-variant="dark"
            style="max-height: 100%; min-height: 300px; margin-top: 10px"
            :items="stock_data"
            :fields="fields"
            :filter="selected_indicator"
            :filter-function="filterTable"
            :busy="isBusy"
            @row-clicked="open_tradingview"
          ></b-table>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import VueTradingView from "vue-trading-view";
import VueTradingView from "../components/tradingview_chart.vue";

import db from "../../database/index";
const trend_data = db.collection("trend_data");

export default {
  name: "Scanner",
  metaInfo: {
    title: "Market Moves - Scanner",
    titleTemplate: "Scanner",
  },
  components: {
    VueTradingView,
  },
  data() {
    return {
      selectSymbol: "NASDAQ:AAPL",
      dataLoaded: false,
      discord_id: "",
      stock_data: [],
      selected_indicator: null,
      indicator_options: [{ value: null, text: "Please select an option" }],
      fields: [
        { key: "time", label: "Time", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "symbol", label: "Symbol", sortable: true},
        {
          key: "indicator",
          label: "Scanner Filter",
          formatter: "getIndicator",
        },
      ],
      isBusy: true,
      indicator_list: [],
      chartOption: {
        // symbol: this.selectSymbol,
        theme: "dark",
        interval: "D",
      },
    };
  },
  async mounted() {
    this.discord_id = this.id;
    this.pull_data()
    setInterval(() =>{
      this.pull_data()
    }, 60000)
  },
  methods: {
    pull_data() {
      trend_data
        .doc("symbol_data")
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            console.log("data ", data);
            this.stock_data = []
            for (const [key, value] of Object.entries(data)) {
              value["symbol"] = key;
              this.stock_data.push(value);
            }
          }
          this.stock_data.sort((a, b) => {
            const aDate = new Date(a.date + ' ' + a.time)
            const bDate = new Date(b.date + ' ' + b.time)
            
            return bDate.getTime() - aDate.getTime()
          })
          this.isBusy = false;
        })
        .then(() => {
          if (this.stock_data.length > 0) {
            this.stock_data.forEach((element) => {
              element["indicator"].forEach((data) => {
                if (!this.indicator_list.includes(data)) {
                  this.indicator_list.push(data);
                  this.indicator_options.push({ value: data, text: data });
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    back_to_button() {
      this.$router.push({ path: "/dashboard" });
    },
    getTime(value) {
      return new Date(value).toLocaleTimeString();
    },
    getDate(value) {
      console.log("Date ", value)
      return new Date(value).toLocaleDateString();
    },
    getIndicator(value) {
      Array.prototype.contains = function (v) {
        for (var i = 0; i < this.length; i++) {
          if (this[i] === v) return true;
        }
        return false;
      };

      Array.prototype.unique = function () {
        var arr = [];
        for (var i = 0; i < this.length; i++) {
          if (!arr.contains(this[i])) {
            arr.push(this[i]);
          }
        }
        return arr;
      };
      let unique_indicator = value.unique();
      return unique_indicator.join(", ");
    },
    getCleanSymbol(value){
      let symbol;
      if (value.includes(".")) {
        value = value.trim()
        symbol = value.split(".")[0];
      } else {
        symbol = value
      }
      return symbol;
    },
    filterTable(row) {
      // let is_stock_match = this.selected_indicator.includes(row.symbol);

      if (row["indicator"].includes(this.selected_indicator)) {
        return true;
      } else {
        return false;
      }
    },
    open_tradingview(record) {
      if (record["symbol"].includes(".")) {
        this.selectSymbol = record["symbol"].split(".")[0];
      } else {
        this.selectSymbol = record["symbol"];
      }

      window.scrollTo(0,0);
      console.log("record ", this.selectSymbol);
    },
  },
};
</script>


<style scoped>
.container {
  color: #f8f8f8;
}
.trade-container {
  height: 240px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}
</style>